import { Link, useLocation} from "react-router-dom";

import { ArrowBackIcon } from "../Icons";
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import backgroundImg from "./../../assets/nightsky/24.jpg";
import Typed from 'typed.js';
import "./../../App.css";

import AboutMe from './../aboutMe';
import Research from './../research';
import TeachingAndService from './../teachingService';
import Projects from './../projects';
import Conferences from './../conferences';

import AboutMeMathMode from './../aboutMeMathMode';
import ResearchMathMode from './../researchMathMode';
import ConferencesMathMode from './../conferencesMathMode';
import TeachingAndServiceMathMode from './../teachingServiceMathMode';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {recognitions} from './../updatables';

import { MotionIcon } from 'motion-icons-react';
import { ItemWrapper } from "../Sidebar/SidebarStyles";
import { ThemeContext } from "../../ThemeContext";

const Item = (props) => {
  const { page } = props;

  console.log("page =", page);

  const el = React.useRef(null);
  const el2 = React.useRef(null);

  const cursorRef = useRef(null);
  const [cursorLine, setCursorLine] = useState("intro");
  const [isTyping, setIsTyping] = useState(false);
  const lastActivityRef = useRef(Date.now());
  const typingTimeoutRef = useRef(null);

  const [isHovered, setIsHovered] = useState(false);

  const location = useLocation();

  const isSmallScreen = useMediaQuery({ maxWidth: 670 });

  const { mathMode } = useContext(ThemeContext);

  function signalTyping() {
    lastActivityRef.current = Date.now();
    setIsTyping(true);
  }

  const [showMobileWarning, setShowMobileWarning] = React.useState(false);

  React.useEffect(() => {
    if (page !== "about me" || !isSmallScreen) return;

    const hasSeenWarning = sessionStorage.getItem("mobileWarningShown");

    if (!hasSeenWarning) {
      setShowMobileWarning(true);
      sessionStorage.setItem("mobileWarningShown", "true");
    }

  }, [page, isSmallScreen]);

  React.useEffect(() => {
    if (!el.current || !el2.current) return;

    let subtitle;

    const intro = new Typed(el.current, {
      strings: [`Hello.^2500`, `Hello, I'm <span style="color:#F087D5">Ori Friesen</span>.^2000`],
      typeSpeed: 75,
      showCursor: false,

      onBegin: () => setCursorLine("intro"),

      onComplete: () => {
        setCursorLine("subtitle");

        setTimeout(() => {
          if (!el2.current) return;

          subtitle = new Typed(el2.current, {
            strings: [
              "I'm a mathematician.",
              "I'm a cartographer.",
              "I'm a web developer.",
              "I'm a night sky photographer.",
              "^2500"
            ],
            typeSpeed: 75,
            backSpeed: 40,
            backDelay: 2500,
            loop: true,
            showCursor: false,
          });
        }, 50);
      }
    });

    return () => {
      intro.destroy();
      if (subtitle) subtitle.destroy();
    };
  }, [location.pathname]);

  if (page === "about me") {
    return mathMode ? <AboutMeMathMode page={page} /> : <AboutMe page={page} />
  }
  else if (page === `\\research`) {
    return mathMode ? <ResearchMathMode page={page} /> : <Research page={page} />;
  }
  else if (page === `\\teaching + service`) {
    return mathMode ? <TeachingAndServiceMathMode page={page} /> : <TeachingAndService page={page} />
  }
  else if (page === `\\extracurriculars`) {
    return mathMode ? <AboutMeMathMode page={page} /> : <Projects page={page} />
  }
  else if (page === `\\conferences`) {
    return mathMode ? <ConferencesMathMode page={page} /> : <Conferences page={page} />;
  }
  else {
    return (
    <div id="page">
    <Link to="/">
    </Link>
    {page}
    </div>
    );
  }
};
export default Item;